exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chat-web-container {\n  font-family: \"Roboto\", \"Helvetica\", \"Helvetica Neue\", \"Arial\" !important;\n  font-size: 14px;\n  text-align: center; }\n  .chat-web-container button, .chat-web-container a, .chat-web-container textarea, .chat-web-container input {\n    font-family: \"Roboto\", \"Helvetica\", \"Helvetica Neue\", \"Arial\" !important; }\n  .chat-web-container a:not(.link-action) {\n    color: #3091f2;\n    font-size: 12px;\n    word-break: break-word; }\n  .chat-web-container b {\n    font-weight: bold !important; }\n", ""]);

// exports
